import React from 'react';
import { createSelector } from '@reduxjs/toolkit';

import { CeilingTray } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { editCeilingTrays } from '../../../../../store/actions/layout/ceilingTrayActions';
import { isLayoutModeViewOnly } from '../../../../../store/selectors/layoutModeSelectors';
import { propertiesShouldBeViewOnly } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { PropertiesPanelMenuButton } from '../PropertiesPanelMenuButton';
import { BulkCeilingTrayPropertyControls, CeilingTrayPropertyControls } from './CeilingTrayPropertyControls';

const shouldBeViewOnly = createSelector(
  [propertiesShouldBeViewOnly, isLayoutModeViewOnly],
  (viewOnlyProperties, viewOnlyLayout) => viewOnlyProperties || viewOnlyLayout,
);

export function CeilingTrayProperties(props: { value: CeilingTray }) {
  const dispatch = useAppDispatch();
  const viewOnly = useAppSelector(shouldBeViewOnly);

  return (
    <PropertiesPanel
      title="Ceiling Tray Properties"
      titleButton={<PropertiesPanelMenuButton type="ceilingTray" guid={props.value.guid} />}
    >
      <CeilingTrayPropertyControls
        tray={props.value}
        onChange={async (patch) => {
          await dispatch(editCeilingTrays([{ guid: props.value.guid, editedProperties: patch }]));
        }}
        disabled={viewOnly}
      />
    </PropertiesPanel>
  );
}

export function BulkCeilingTrayProperties(props: { trays: CeilingTray[] }) {
  const dispatch = useAppDispatch();
  const viewOnly = useAppSelector(shouldBeViewOnly);

  return (
    <PropertiesPanel
      title="Multiple Ceiling Trays"
      titleButton={<PropertiesPanelMenuButton type="ceilingTray" guid={props.trays[0].guid} />}
    >
      <BulkCeilingTrayPropertyControls
        trays={props.trays}
        onChange={async (edits) => {
          await dispatch(editCeilingTrays(edits));
        }}
        disabled={viewOnly}
      />
    </PropertiesPanel>
  );
}
